
import {
  campaign
} from '../constants';

/**
 * Import constants
 */
const {
  SET_HAS_ACTIVE_CAMPAIGN,
  SET_CAMPAIGN_INFO,
  TRIGGER_CAMPAIGN
} = campaign;


/**
 * Action creators
 */
const actions = {
  setHasActiveCampaign: (data) => ({ type: SET_HAS_ACTIVE_CAMPAIGN, data }),
  setCampaignInfo: (data) => ({ type: SET_CAMPAIGN_INFO, data }),
  triggerCampaign: (data) => ({ type: TRIGGER_CAMPAIGN, data })
};


/**
 * Set has active campaign
 */
export const setHasActiveCampaign = (active) => (dispatch) => {
  dispatch(actions.setHasActiveCampaign(active));
};


/**
 * Set Campaign information
 */
export const setCampaignInfo = (info) => (dispatch) => dispatch(actions.setCampaignInfo(info));


/**
 * Set Campaign state
 */
export const triggerCampaign = (state) => (dispatch) => dispatch(actions.triggerCampaign(state));
